import './ContentHeroBlock.scss';
import { ContentHeroBlockData } from '../../models/app-data-model';
import ContentHero from "../content-hero/ContentHero";

import React from 'react';

export type ContentHeroBlockProps = {
  contentHeroBlock: ContentHeroBlockData;
};

const ContentHeroBlock: React.FC<ContentHeroBlockProps> = ({ contentHeroBlock }) => {
  return <div>
    {contentHeroBlock.content_hero && contentHeroBlock.content_hero.length > 0 && <ContentHero contentHeroData={contentHeroBlock.content_hero[0]} />}
  </div>;
};

export default ContentHeroBlock;
